export const formatFilterTitle = (filterLabel, activeFiltersCount, isRequestResult = false) => {
    if (activeFiltersCount === 0 && !isRequestResult) {
        return filterLabel;
    }
    return `${filterLabel} (${activeFiltersCount})`;
};
export const getSubmitMobileLabel = (isRequestResult, defaultLabel, showedItems) => {
    const label = defaultLabel.replace('{ofAmount}', '');
    return isRequestResult ? label : defaultLabel.replace('{ofAmount}', `${showedItems}`);
};
export const getActiveAmount = (filtersItems, currentLabel) => {
    const currentItem = filtersItems.find((item) => item.name === currentLabel)?.value;
    const amount = currentItem?.length ? ` (${currentItem.length})` : '';
    return `${currentLabel}${amount}`;
};
